window.addEventListener("load", () => {
  new SantanderInstallmentCalculator()
})

class SantanderInstallmentCalculator {
  constructor() {
    const storeNumberElement = document.getElementById("sci")
    this.storeNumber = storeNumberElement
      ? storeNumberElement.dataset.value
      : null

    this.bindButtons()
  }

  calculateInstallment(cartValue) {
    const url = `https://wniosek.eraty.pl/symulator/oblicz/numerSklepu/${this.storeNumber}/typProduktu/0/wartoscTowarow/${cartValue || 2000}/liczbaRat/12`
    window.open(
      url,
      "Policz_rate",
      "width=630,height=500,directories=no,location=no,menubar=no,resizable=yes,scrollbars=yes,status=no,toolbar=no",
    )
  }

  openProcedurePage() {
    window.open(
      "https://www.santanderconsumer.pl/raty-jak-kupic",
      "new_window",
      "width=600,height=500,directories=no,location=no,menubar=no,resizable=yes,scrollbars=yes,status=no,toolbar=no",
    )
  }

  bindButtons() {
    const rateButtons = document.querySelectorAll(
      ".calculate-installment-button",
    )
    rateButtons.forEach((rateButton) => {
      const cartValue = rateButton.dataset.value
      rateButton.addEventListener("click", () =>
        this.calculateInstallment(cartValue),
      )
    })

    const procedureButtons = document.querySelectorAll(".open-procedure-button")
    procedureButtons.forEach((procedureButton) => {
      procedureButton.addEventListener("click", () => this.openProcedurePage())
    })

    const form = document.querySelector(".validate-santander-form")
    if (form) {
      form.addEventListener("submit", (event) => {
        const checkbox = document.getElementById("agreement_checkbox")

        if (!checkbox.checked) {
          event.preventDefault()

          alert(
            "Zanim złożysz zamówienie, zapoznaj sie z procedura udzielenia kredytu ratalnego eRaty Santander Consumer Bank.",
          )

          const loaderHandler = document.querySelector(".loader-handler")
          loaderHandler.classList.remove("loading")
        }
      })
    }
  }
}
